import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import { connect, useDispatch, useSelector } from "react-redux"
import { withRouter } from "react-router-dom"
import { Button, CardText, CardTitle } from "reactstrap"
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  getProfileDetails,
} from "../../store/actions"

// Layout Related Components
import CardComponent from "components/Card"
import BarChart from "components/Chart/BarChart"
import TableComponent from "components/Table"
import { AiFillPlusCircle } from "react-icons/ai"
import Header from "./Header"
import "./styles.scss"

import Calendar from "react-calendar"
import "react-calendar/dist/Calendar.css"

const Layout = props => {
  const dispatch = useDispatch()
  const { profile } = useSelector(state => state.Profile)
  const [state, setState] = useState({
    isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
  })
  const [startDate, setStartDate] = useState(new Date("5/12/2023"))
  const [endDate, setEndDate] = useState(new Date("12/12/2023"))
  const [startDateIsOpen, setStartDateIsOpen] = useState(false)
  const [endDateIsOpen, setEndDateIsOpen] = useState(false)
  const handleChangeStartDate = e => {
    setStartDateIsOpen(!startDateIsOpen)
    setStartDate(e)
  }
  const handleClickStartDate = e => {
    e.preventDefault()
    setStartDateIsOpen(!startDateIsOpen)
  }
  const handleChangeEndDate = e => {
    setEndDateIsOpen(!endDateIsOpen)
    setEndDate(e)
  }
  const handleClickEndDate = e => {
    e.preventDefault()
    setEndDateIsOpen(!endDateIsOpen)
  }

  const toggleMenuCallback = () => {
    if (props.leftSideBarType === "default") {
      props.changeSidebarType("condensed", state.isMobile)
    } else if (props.leftSideBarType === "condensed") {
      props.changeSidebarType("default", state.isMobile)
    }
  }

  // const labels = ["January", "February", "March", "April", "May", "June"]

  // const data = {
  //   labels,
  //   datasets: [
  //     {
  //       label: "USAGE",
  //       data: [2600, 1500, 2500, 3500, 3000, 2200],
  //       backgroundColor: "#f15331",
  //     },
  //     {
  //       label: "DEMAND",
  //       data: [1300, 2000, 3000, 4000, 3500, 2500],
  //       backgroundColor: "#015eb4",
  //     },
  //   ],
  // }

  const data = [
    {
      month: "JAN",
      USAGE: 2000,
      usageColor: "#f15331",
      DEMAND: 4000,
      demandColor: "#015eb4",
    },
    {
      month: "FEB",
      USAGE: 2000,
      usageColor: "#f15331",
      DEMAND: 4000,
      demandColor: "#015eb4",
    },
    {
      month: "MAR",
      USAGE: 5000,
      usageColor: "#f15331",
      DEMAND: 8000,
      demandColor: "#015eb4",
    },
    {
      month: "APR",
      USAGE: 2000,
      usageColor: "#f15331",
      DEMAND: 5000,
      demandColor: "#015eb4",
    },
    {
      month: "MAY",
      USAGE: 5000,
      usageColor: "#f15331",
      DEMAND: 4000,
      demandColor: "#015eb4",
    },
    {
      month: "JUN",
      USAGE: 7000,
      usageColor: "#f15331",
      DEMAND: 5000,
      demandColor: "#015eb4",
    },
  ]

  const InvoiceCardBody = () => {
    return (
      <>
        <CardText style={{ color: "#838b92", fontSize: "0.7rem" }}>
          You are 10 days into your billing cycle
        </CardText>
        <h1 style={{ color: "#cacbcc", fontSize: "3rem", fontWeight: "900" }}>
          $56.00
        </h1>
        <CardText style={{ color: "#6e7d8a", fontSize: "1rem" }}>
          Payment due <br /> <span style={{ color: "#f3684b" }}>5/1/23</span>
        </CardText>
        <Button color="primary" outline className="rounded-4 px-4">
          <AiFillPlusCircle /> See details
        </Button>
      </>
    )
  }

  const ColorCircle = ({ color, size }) => (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: color,
        marginRight: "5px",
      }}
    />
  )

  const UsageCardBody = () => {
    return (
      <>
        <div id="chart" dir="ltr" style={{ width: "345px", height: "300px" }}>
          <BarChart data={data} />
        </div>
        <div className="text-center">
          <span className="mx-2">
            <ColorCircle color="#f15331" size="10px" />
            <span>USAGE </span>
          </span>
          <ColorCircle color="#015eb4" size="10px" />
          <span>DEMAND </span>
        </div>
      </>
    )
  }

  const dateFilter = () => {
    return (
      <>
        <span
          style={{ color: "blue", padding: "5px" }}
          className="border"
          onClick={handleClickStartDate}
        >
          Start Date
        </span>
        {startDateIsOpen && (
          <div style={{ position: "absolute" }}>
            <Calendar
              selected={startDate}
              onChange={handleChangeStartDate}
              minDate={new Date("1/1/2023")}
              maxDate={new Date("12/31/2023")}
            />
          </div>
        )}
        <span className="border" style={{ padding: "5px" }}>
          <span>{`${startDate?.toLocaleString("default", {
            month: "long",
          })}-${startDate?.getDate()}`}</span>
          <i className="mdi mdi-arrow-right mx-1"></i>
          <span>{`${endDate?.toLocaleString("default", {
            month: "long",
          })}-${endDate?.getDate()}`}</span>
        </span>
        <span
          style={{ color: "blue", padding: "5px" }}
          className="border"
          onClick={handleClickEndDate}
        >
          End Date
        </span>
        {endDateIsOpen && (
          <div style={{ position: "absolute" }}>
            <Calendar
              selected={endDate}
              onChange={handleChangeEndDate}
              minDate={new Date("1/1/2023")}
              maxDate={new Date("12/31/2023")}
            />
          </div>
        )}
      </>
    )
  }

  const BillingCardBody = () => {
    return (
      <>
        <div className="d-flex">
          <div className="w-50">
            <CardTitle className="h3" style={{ color: "#9aa2a8" }}>
              Previous bills and payments{" "}
            </CardTitle>
            <p className="card-title-desc" style={{ color: "#9aa2a8" }}>
              Please note: debit and credit card payments will display in 24-72
              hours.
            </p>
          </div>
          <div className="w-50 p-1 text-end mt-4">{dateFilter()}</div>
        </div>
        <div className="table-responsive" data-pattern="priority-columns">
          <TableComponent />
        </div>
      </>
    )
  }

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("authUser"))
    if (!profile?.email) {
      dispatch(getProfileDetails(user))
    }
  }, [profile])

  useEffect(() => {
    if (props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block"
      document.getElementById("status").style.display = "block"

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
      }, 2500)
    } else {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    }

    // Scroll Top to 0
    window.scrollTo(0, 0)

    if (props.leftSideBarTheme) {
      props.changeSidebarTheme(props.leftSideBarTheme)
    }

    if (props.layoutWidth) {
      props.changeLayoutWidth(props.layoutWidth)
    }

    if (props.leftSideBarType) {
      props.changeSidebarType(props.leftSideBarType)
    }
    if (props.topbarTheme) {
      props.changeTopbarTheme(props.topbarTheme)
    }
  }, [])

  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />

        <div className="page-content">
          <div style={{ position: "relative" }}>
            <div
              className=""
              style={{
                background:
                  "linear-gradient(180deg, rgba(20,105,180,1) 0%, rgba(100,152,182,1) 100%)",
                // backgroundImage: "linear-gradient(#1469b4, #6498b6)",
                height: "6rem",
                borderRadius: "0px",
              }}
            >
              {" "}
            </div>
            <div
              style={{
                zIndex: 2,
                marginTop: -30,
                background: "#f5f5f5",
                padding: "1rem",
                borderRadius: "3px",
                justifyContent: "center",
                marginRight: "1.5rem",
                marginLeft: "1.5rem",
              }}
            >
              <div className="content-container">
                <div className="content-sidebar">
                  <CardComponent title="Most Recent" subtitle="Invoice Summary">
                    {InvoiceCardBody()}
                  </CardComponent>
                  <CardComponent title="" subtitle="Usage History">
                    {UsageCardBody()}
                  </CardComponent>
                </div>
                <div className="main-content-area">
                  <CardComponent
                    subtitle="Billing History"
                    alignHeader="left"
                    alignContent="left"
                  >
                    {BillingCardBody()}
                  </CardComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
}

const mapStatetoProps = state => {
  return {
    ...state.Layout,
  }
}
export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
})(withRouter(Layout))
